var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tse-button",class:[
    _vm.type ? 'tse-button--' + _vm.type : '',
    _vm.size ? 'tse-button--' + _vm.size : '',
    {
      'is-disabled': _vm.disabled,
      'is-plain': _vm.plain,
      'is-square': _vm.square,
      'is-shadow':_vm.shadow,
      'is-opacity':_vm.opacity
    }
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }